import React from "react";
import { Box } from "@mui/material";
import { splitHighlight } from "./explorerFilterUtils";

/** Renders text with matched search substrings visually highlighted. */
export default function HighlightedText({ text, term }) {
  const segments = splitHighlight(text, term);
  if (segments.length === 1 && !segments[0].match) {
    return <span>{segments[0].text}</span>;
  }
  return (
    <span>
      {segments.map((seg, i) =>
        seg.match ? (
          <Box
            key={i}
            component="mark"
            sx={{
              bgcolor: "warning.main",
              color: "warning.contrastText",
              borderRadius: 0.5,
              px: 0.25,
            }}
          >
            {seg.text}
          </Box>
        ) : (
          <span key={i}>{seg.text}</span>
        )
      )}
    </span>
  );
}
